import React, { useState } from 'react';

function LoginForm({ onLogin, onCancel, onRegister }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isRegister, setIsRegister] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (isRegister) {
      onRegister(name.trim(), email, password);
    } else {
      onLogin(email, password);
    }

    setName('');
    setEmail('');
    setPassword('');
  };

  return (
    <div className="modal-backdrop login-modal-backdrop" onClick={onCancel}>
      <div
        className="modal login-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="login-modal-title"
      >
        <div className="modal-header">
          <h2 className="modal-title" id="login-modal-title">
            {isRegister ? 'Register' : 'Login'}
          </h2>
          <button type="button" className="modal-close" onClick={onCancel} aria-label="Close">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {isRegister && (
            <input
              type="text"
              placeholder="Your name"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
              className="form-control"
            />
          )}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            className="form-control"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
            className="form-control"
          />

          <div className="login-form-actions">
            <button type="submit" className="btn btn-primary login-submit-btn">
              {isRegister ? 'Register' : 'Login'}
            </button>
            <button type="button" className="btn btn-secondary login-cancel-btn" onClick={onCancel}>
              Cancel
            </button>
          </div>

          <div className="login-switch-row">
            <button
              type="button"
              className="login-switch-btn"
              onClick={() => setIsRegister((currentValue) => !currentValue)}
            >
              {isRegister ? 'Already have an account? Login' : "Don't have an account? Register"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
